import { render, staticRenderFns } from "./indexCopy.vue?vue&type=template&id=6c9d7d11&scoped=true"
import script from "./indexCopy.vue?vue&type=script&lang=js"
export * from "./indexCopy.vue?vue&type=script&lang=js"
import style0 from "./indexCopy.vue?vue&type=style&index=0&id=6c9d7d11&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9d7d11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c9d7d11')) {
      api.createRecord('6c9d7d11', component.options)
    } else {
      api.reload('6c9d7d11', component.options)
    }
    module.hot.accept("./indexCopy.vue?vue&type=template&id=6c9d7d11&scoped=true", function () {
      api.rerender('6c9d7d11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/customerTimelinessManagement/indexCopy.vue"
export default component.exports